module.exports = __webpack_public_path__ + "static/media/create_segmnent_icon.d34ceccf.svg";